import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    } else {
      e.preventDefault();
      const element = document.getElementById('oferta');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        window.location.hash = 'oferta';
      }
    }
  };
  return <a href="#oferta" onClick={handleClick} className={`${`${`w-full md:w-auto btn-premium font-bold py-4 px-10 rounded-xl transition-all duration-300 text-base md:text-xl flex items-center justify-center gap-2 hover:scale-[1.02] active:scale-95 no-underline whitespace-nowrap ${className}`} text-[14px]`} text-[14px]`} data-id="element-100">
      {'\uD83D\uDC47 QUIERO PREPARAR MI HOGAR HOY'}
    </a>;
}